import { GetStaticPaths, GetStaticProps } from 'next';
import { getAllPostSlugs, getRedirectPaths } from '@api';
import { getStaticPropsCore } from '@/src/getStatic/getStaticPropsCore';

export { default } from '@/src/pages/knowledge/blog/[slug]';

export const getStaticProps = async ({
  params,
}: Parameters<GetStaticProps<any, { slug: string }>>[0]) => {
  console.info(`getStaticProps /interview/${params?.slug}`);
  return await getStaticPropsCore(params?.slug || '', {
    pathIsInterview: true,
    redirectionReferencePath: `/knowledge/interview/${params?.slug}/`,
  });
};

export const getStaticPaths: GetStaticPaths = async () => {
  const redirects = await getRedirectPaths();

  return {
    paths: (await getAllPostSlugs({ where: { categoryName: 'interview' } }))
      .map((slug) => `/knowledge/interview/${slug}`)
      .filter((path) => !redirects.has(`${path}/`)),
    fallback: 'blocking',
  };
};
